export const offensiveValues = {
  goals: {
    categoryIds: [12, 55, '35_r', '54_r'],
    translationKey: 'local_vs_away.offensive.goals',
    singleName: 'Gol',
  },
  goalShots: {
    categoryIds: [510],
    translationKey: 'local_vs_away.offensive.shots_on_goal',
    singleName: 'Tiro a gol',
  },
  leftCenteringPass: {
    categoryIds: [13],
    translationKey: 'local_vs_away.offensive.centers_from_left',
    singleName: 'Centro por izquierda',
  },
  rightCenteringPass: {
    categoryIds: [25],
    translationKey: 'local_vs_away.offensive.centers_from_right',
    singleName: 'Centro por derecha',
  },
};

export const defensiveValues = {
  recoveredBalls: {
    categoryIds: [483, 484],
    translationKey: 'local_vs_away.defensive.balls_recovered',
    singleName: 'Balón recuperado',
  },
  recoveredBallsRivalField: {
    categoryIds: [487, 488, 491, 492],
    translationKey: 'local_vs_away.defensive.balls_recovered_opponents_half',
    singleName: 'Balón recuperado cancha rival',
  },
  airBallWonAtOwnArea: {
    categoryIds: [23],
    translationKey: 'local_vs_away.defensive.balls_won_own_penalty_box',
    singleName: 'Balón ganado área rival',
  },
  rejections: {
    categoryIds: [34],
    translationKey: 'local_vs_away.defensive.clearances',
    singleName: 'Rechace',
  },
};
